import { Logistics } from "@secondcloset/types";

import { getAPIFromDomain } from "../../../lib/api";

export const fetchServiceArea = async () => {
  const api = getAPIFromDomain("logistics");
  const url = "/service_areas";
  const response = await api.get(url);

  return response.data as Logistics.ServiceArea[];
};
